// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"aV-z","inlineTitle":"bV-z","sponsoredAdsWrapper":"cV-z","marketplaceRecosWrapper":"dV-z"};